import Entities from 'STORE';

export function closeVideoPlayer(): void {
  Entities.GlobalVideoPlayer.reset();
}
